import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
} from "@angular/router";
import { MsalService } from "@azure/msal-angular";
import { AppConstants } from "../constants/constants";
import { PublicUserSessionService } from "../_services/public-user-session.service";
import { firstValueFrom } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DirectAccessGuard implements CanActivate {
  previousUrl: string;
  savedNextUrl: string;

  constructor(
    private router: Router,
    private userSessionService: PublicUserSessionService,
    private msalService: MsalService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    let isAllowAccessContent = await firstValueFrom(this.userSessionService
      .getIsAllowAccessContent$());
    let isAllow = isAllowAccessContent
      ? JSON.parse(isAllowAccessContent) === true
      : false;
    if (!isAllow) {
      const account = this.msalService.instance.getActiveAccount();
      if (!account)
        return this.router.createUrlTree([AppConstants.WELCOME_PAGE]);

      return this.router.createUrlTree([AppConstants.DASHBOARD_PAGE]);
    }

    this.previousUrl = sessionStorage.getItem(AppConstants.PREV_PATH);
    this.savedNextUrl = sessionStorage.getItem(AppConstants.NEXT_PATH);
    return this.checkDirectAccessFromContent(
      route,
      this.savedNextUrl,
      state.url
    );
  }

  checkDirectAccessFromContent(
    route: ActivatedRouteSnapshot,
    sessionNextUrl: string,
    nextUrl: string
  ): boolean {
    const fromLearningResource =
      route.queryParams[AppConstants.FROM_LEARNING_RESOURCES];

    if (fromLearningResource === AppConstants.TRUE) {
      return true;
    }
    if (this.previousUrl == null) {
      this.router.navigate([AppConstants.DASHBOARD_PAGE]);
      return false;
    }
    //If condition is matched, it will allow to refresh and stay on content.
    if (this.router.navigated) {
      sessionStorage.setItem(AppConstants.NEXT_PATH, nextUrl);
      return true;
    } else {
      if (sessionNextUrl == nextUrl) return true;
      else return this.redirectToDashboard();
    }
  }

  redirectToDashboard(): boolean {
    this.router.navigate([AppConstants.DASHBOARD_PAGE]);
    return false;
  }
}
